import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Modal } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import {
  BootsIcon,
  CloseIcon,
  DownloadIcon,
  FullScreenIcon,
  GlovesIcon,
  HelmetIcon,
  LeftIcon,
  RightIcon,
  VestIcon,
} from "../../assets/Icons";
import moment from "moment/moment";

const ViolationModal = ({ photosModal, setPhotosModal, images, loading }) => {
  const [activeImage, setActiveImage] = useState(null);

  const handleImageClick = (image, index) => {
    setActiveImage({ ...image, index: index });
  };

  const handleCloseFullscreen = () => {
    setActiveImage(null);
  };

  const nextClickHandler = () => {
    setActiveImage({ ...images[activeImage?.index + 1], index: activeImage?.index + 1 });
  };

  const preClickHandler = () => {
    setActiveImage({ ...images[activeImage?.index - 1], index: activeImage?.index - 1 });
  };

  const handleClickDownloadFile = (url) => {
    let fileName = url.split("/").pop();
    let fileExt = fileName.split(".").pop();

    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.download = url.split("/").pop() + "." + fileExt;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const onCloseModal = () => {
    setPhotosModal(false);
    setTimeout(() => {
      setActiveImage(null);
    }, 1000);
  };

  return (
    <Modal
      className={activeImage ? "single-view violation-modal" : "violation-modal"}
      show={photosModal}
      size="xl"
      centered
      onHide={onCloseModal}
    >
      {!activeImage && (
        <Modal.Header className="modalheader">
          Recent Violations
          <span onClick={onCloseModal}>
            <CloseIcon />
          </span>
        </Modal.Header>
      )}
      <Modal.Body className="my-2 pt-0">
        {activeImage ? (
          <div className="images-container">
            <div className="row">
              <div className="image-side">
                <img src={activeImage?.url} alt="Violation" className="img-fluid" />
                <div className="violation-details">
                  <span className="violation-data-list">
                  </span>
                  <p className="violation-time">{moment(activeImage?.createdAt).format("LLL")}</p>
                </div>
                <div className="function-items">
                  <span className="showmore" onClick={handleCloseFullscreen}>
                    &lt; Recent Violations
                  </span>
                  <div className="action-btns">
                    <Tooltip title="Download Snapshot">
                      <span onClick={() => handleClickDownloadFile(activeImage?.url)}>
                        <DownloadIcon />
                      </span>
                    </Tooltip>
                    <span onClick={onCloseModal}>
                      <CloseIcon />
                    </span>
                  </div>
                </div>
                {activeImage?.index < images?.length - 1 && (
                  <span className="next-btn" onClick={nextClickHandler}>
                    <RightIcon />
                  </span>
                )}
                {activeImage?.index !== 0 && (
                  <span className="pre-btn" onClick={preClickHandler}>
                    <LeftIcon />
                  </span>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="gallery-container">
            {loading ? (
              <>
                {[...Array(5)].map((_, index) => (
                  <span className="image-box">
                    <Skeleton width="100%" height="100%" />
                  </span>
                ))}
              </>
            ) : (
              <>
                {images?.map((item, index) => (
                  <span className="image-box" key={item?.uuid} onClick={() => handleImageClick(item, index)}>
                    <img src={item?.url} alt={`Violation ${index + 1}`} className="img-thumbnail" />
                    <span className="fullscreen-btn">
                      <FullScreenIcon />
                    </span>
                    <span className="violation-cat">
                    </span>
                  </span>
                ))}
              </>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViolationModal;
